import { useReducer } from 'react';
import CartContext, { CartContextType, CartItemProps } from "./cart-context"

enum CartActionKind {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  EMPTY = 'EMPTY'
}

interface CartAction {
  type: CartActionKind;
  payload: any;
}

const defaultCartState: CartContextType = {
  items: [],
  totalAmount: 0,
  membershipString: ''
};

const cartReducer = (state: CartContextType, action: CartAction) => {

  const buildMembership = (products: CartItemProps[]) => {
    let memOrderString = '';
    if (products.length === 1) {
      if (products[0].amount === 1) {
        return products[0].membership;
      }
    }
    products.map(item => {
      if (item.amount.toString().length > 3) {
        return 'lifetime_membership';
      }
      return memOrderString += memOrderString ? ` and ${item.amount} x ${item.membership}` : `${item.amount} x ${item.membership}`;
    });
    return memOrderString;
  };

  if (action.type === CartActionKind.ADD) {
    const existingCartItemIndex = state.items.findIndex(
      (item: CartItemProps) => item.membership === action.payload.membership
    );

    const existingCartItem = state.items[existingCartItemIndex];

    let updatedItems: CartItemProps[];

    if (existingCartItem) {
      let updatedItem;
      updatedItem = {
        ...existingCartItem,
        amount: existingCartItem.amount + action.payload.amount
      };
      updatedItems = [...state.items];
      updatedItems[existingCartItemIndex] = updatedItem;
    } else {
      updatedItems = state.items.concat(action.payload);
    }

    const updatedTotalAmount = state.totalAmount + action.payload.amount * action.payload.price;

    return {
      items: updatedItems,
      totalAmount: updatedTotalAmount,
      membershipString: buildMembership(updatedItems)
    };
  }

  if (action.type === CartActionKind.REMOVE) {
    const existingItemIndex = state.items.findIndex(
      (item: CartItemProps) => item.membership === action.payload
    );

    const existingItem = state.items[existingItemIndex];
    const updatedTotalAmount = state.totalAmount - existingItem.price;
    let updatedItems;
    if (existingItem.amount === 1) {
      updatedItems = state.items.filter(item => item.membership !== action.payload)
    } else {
      const updatedItem = { ...existingItem, amount: existingItem.amount - 1 };
      updatedItems = [...state.items];
      updatedItems[existingItemIndex] = updatedItem;
    }

    return {
      items: updatedItems,
      totalAmount: updatedTotalAmount,
      membershipString: buildMembership(updatedItems)
    };
  }

  if (action.type === CartActionKind.EMPTY) {
    return {
      items: [],
      totalAmount: 0,
      membershipString: ''
    }
  }
  return defaultCartState;
};

const CartProvider:React.FC<React.ReactNode> = ({ children }) => {

  const [cartState, dispatch] = useReducer(cartReducer, defaultCartState);

  const addItemToCartHandler = (item: CartItemProps) => {
    dispatch({
      type: CartActionKind.ADD,
      payload: item
    });
  };

  const removeItemToCartHandler = (membership: string) => {
    dispatch({
      type: CartActionKind.REMOVE,
      payload: membership
    });
  };

  const emptyCartHandler = () => {
    dispatch({
      type: CartActionKind.EMPTY,
      payload: null
    });
  }

  const cartContext = {
    items: cartState.items,
    totalAmount: cartState.totalAmount,
    membershipString: cartState.membershipString,
    addItem: addItemToCartHandler,
    removeItem: removeItemToCartHandler,
    emptyCart: emptyCartHandler
  };

  return (
    <CartContext.Provider value={cartContext}>
      { children }
    </CartContext.Provider>
  )
};

export default CartProvider;
